"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var css = styled_components_1.default.div;
exports.default = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n   position: relative;\n   display: inline-block;\n\n   input {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      background: red;\n      z-index: 10;\n      opacity: 0;\n      cursor: pointer;\n   }\n"], ["\n   position: relative;\n   display: inline-block;\n\n   input {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      background: red;\n      z-index: 10;\n      opacity: 0;\n      cursor: pointer;\n   }\n"])));
var templateObject_1;
//# sourceMappingURL=UploadFiles.style.js.map